import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-and_jax_5dadd5786005078aecf7d486060d9318",
  "use": "ico-and_jax_5dadd5786005078aecf7d486060d9318-usage",
  "viewBox": "0 0 21 32",
  "content": "<symbol viewBox=\"0 0 21 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-and_jax_5dadd5786005078aecf7d486060d9318\">\n<path d=\"M18.7197 11.6304L11.8857 18.4634L18.7197 25.2974L17.3057 26.7114L10.4717 19.8774L3.64941 26.7007L2.23438 25.2866L9.05762 18.4634L2.23438 11.6401L3.64941 10.2261L10.4717 17.0483L17.3057 10.2163L18.7197 11.6304Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol